import RegistrationInput from "../../components/UI/Registration/RegistrationInput";
import RegistrationSelect from "../../components/UI/Registration/RegistrationSelect";
import BaseInput from "../../components/UI/BaseInput/BaseInput";
import BaseSelect from "../../components/UI/BaseSelect/BaseSelect";
import { store } from "../../store/redux/store";
import { Box, Typography, Switch } from "@mui/material";
import { Autocomplete } from "@react-google-maps/api";
import { Controller } from "react-hook-form";
import { EditInput } from "../../components/UI/Registration/RegistrationInput";
import { useJsApiLoader } from "@react-google-maps/api";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import countries from "i18n-iso-countries";
import { useSelector } from "react-redux";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TextField, InputLabel } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

export const useConfig = () => {
  return useSelector((state) => state.config);
};


export const renderTransferField = (field, selectOption, register, errors, handleContactChange) => {

  const newOptions = Array.isArray(selectOption)
  ? selectOption.map(item => {
      const { id, firstName, lastName } = item.Usercontactlistexternal;
      return {
        key: id,
        value: id,
        label: `${firstName} ${lastName}`,
      };
    })
  : selectOption && typeof selectOption === 'object' && selectOption.Usercontactlistexternal
  ? [{
      key: selectOption.Usercontactlistexternal.id,
      value: selectOption.Usercontactlistexternal.id,
      label: `${selectOption.Usercontactlistexternal.firstName} ${selectOption.Usercontactlistexternal.lastName}`,
    }]
  : [{ key: "not-available", value: "not-available", label: "Not Available" }];

  newOptions.unshift({ key: "", value: "", label: "Add Contact" });

  // console.log(newOptions)

  switch (field.type) {
    case "text":
    case "email":
    case "number":
    case "date":
      return (
        <BaseInput
          {...register(field.name)}
          label={field.label}
          type={field.type}
          errorMessage={errors[field.name]?.message}
          disabled={field.disabled}
        />
      );
    case "radio":
      return (
        <Box key={field.name}>
          {field.label}:{" "}
          {field.options.map((option) => (
            <label key={option.value}>
              <input
                type="radio"
                value={option.value}
                {...register(field.name)}
              />
              {option.label}
            </label>
          ))}
          <p>{errors.errorMessage}</p>
        </Box>
      );
    case "select":
      return (
        <BaseSelect
          key={field.name}
          {...register(field.name)}
          options={newOptions}
          label={field.label}
          name={field.name}
          errorMessage={errors}
          disabled={field.disabled}
          onSelect={(e) => {
            // console.log(e)
          }}
          onChange={(e) => {
            register(field.name).onChange(e);
            if (field.name === "contactbook") {
              handleContactChange(e.target.value);
            }
          }}
        />
      );
    default:
      return null;
  }
}

//This function is used to render the fields in the form with the registration styling
export const renderRegistrationField = (
  field, 
  register, 
  errors, 
  stateOptions, 
  setValue, 
  trigger, 
  autocompleteRef,
  getValues,
  isLoaded,
  disable,
  roles,
  buttonPressed,
  customerTypes,
  customerSubTypes,
  setSelectedCustomerType,
  handleAddBussinessToggleBit,
  configData
) => {


  // console.log(errors)
if (autocompleteRef) {
  
}
  const onLoad = (autocompleteInstance) => {
    autocompleteRef.current = autocompleteInstance;
  };

  const handlePlaceChanged = () => {
    if (autocompleteRef.current) {
      const place = autocompleteRef.current.getPlace();

      // console.log(field)

      // console.log(place)

      if (place.address_components) {
        let address = "", city = "", state = "", country = "", zip = "";

        place.address_components.forEach((component) => {
          const types = component.types;
          if (types.includes("street_number") || types.includes("route") || types.includes("neighborhood")) {
            address = `${address} ${component.long_name}`.trim();
          }
          if (types.includes("locality") || types.includes("sublocality_level_1")) {
            city = component.long_name;
          }
          if (types.includes("administrative_area_level_1")) {
            state = component.short_name;
          }
          if (types.includes("country")) {
            country = component.short_name;
          }
          if (types.includes("postal_code")) {
            zip = component.long_name;
          }
        });

        // console.log(address, city, state, country, zip)

        // Update your form fields with the extracted data
        // setValue("address", address, { shouldValidate: true });
        // setValue("city", city, { shouldValidate: true });
        // setValue("stateid", state, { shouldValidate: true });
        // setValue("state", state, { shouldValidate: true });
        // setValue("country", country, { shouldValidate: true });
        // setValue("zip", zip, { shouldValidate: true });
        // trigger(["address", "city", "stateid", "country", "zip"]);)

        if (field.name === "address") {
          setValue("address", address, { shouldValidate: true });
          setValue("city", city, { shouldValidate: true });
          // setValue("stateid", state, { shouldValidate: true });
          // setValue("state", state, { shouldValidate: true });
          // setValue("country", country, { shouldValidate: true });
          setValue("zip", zip, { shouldValidate: true });
        }
        else {
          setValue("businessaddress", address, { shouldValidate: true });
          setValue("businesscityname", city, { shouldValidate: true });
          // setValue("businessstate", state, { shouldValidate: true });
          // setValue("businesscountry", country, { shouldValidate: true });
          setValue("businesszip", zip, { shouldValidate: true });
        }

        // console.log(getValues("address"))
        // console.log(getValues("city"))
        // console.log(getValues("stateid"))
        // console.log(getValues("country"))
        // console.log(getValues("zip"))
      }
    }
  };

  switch (field.type) {
    case "text":
    case "email":
    case "number":
    case "date":
      if (field.name === "address" || field.name === "businessaddress") {

        if (!isLoaded) {
          return <p>Loading Google Maps...</p>; // You can customize this loading indicator
        }

        return (
          <Box 
          sx={{
            minWidth: "50%",
          }}
          >
          {configData.showAddress ? <Autocomplete
              onLoad={onLoad}
              onPlaceChanged={handlePlaceChanged}
            >
            <RegistrationInput
                {...register(field.name)}
                label={field.label}
                type={field.type}
                placeholder={field.placeholder}
                errorMessage={errors[field.name]?.message}
                disabled={field.disabled || disable}
                required={field.validation?.required}
                value={getValues(field.name) ?? ""}
                buttonPressed={buttonPressed}
              />
            </Autocomplete>
            :
            <RegistrationInput
                {...register(field.name)}
                label={field.label}
                type={field.type}
                placeholder={field.placeholder}
                errorMessage={errors[field.name]?.message}
                disabled={field.disabled || disable}
                required={field.validation?.required}
                value={getValues(field.name) ?? ""}
                buttonPressed={buttonPressed}
              />
          }
          </Box>
        );
      } else {
        return (
          <RegistrationInput
            {...register(field.name)}
            label={field.label}
            type={field.type}
            placeholder={field.placeholder}
            errorMessage={errors[field.name]?.message}
            disabled={field.disabled || disable}
            required={field.validation?.required}
            value={getValues(field.name) ?? ""}
            setValue={setValue}
            buttonPressed={buttonPressed}
          />
        );
      }
    case "radio":
      const options = typeof field.options === "string" ? JSON.parse(field.options) : field.options;
      return (
        <div key={field.name}>
          {field.label}:{" "}
          {options.map((option) => (
            <label key={option.value}>
              <input
                type="radio"
                value={option.value}
                {...register(field.name)}
              />
              {option.label}
            </label>
          ))}
          <p>{errors.errorMessage}</p>
        </div>
      );
    // Need to review for better dynamic rendering
    case "select":
      if ((field.name === "country" || field.name === "state" || field.name === "stateid" || field.name === "businesscountryidlist" || field.name === "businessstateid") && Array.isArray(field.options) && field.options.length > 0) {
        const currentValue = getValues(field.name);
        if (!currentValue) {
          setValue(field.name, field.options[0].value);
        }
      }
      
      return (
        <RegistrationSelect
          key={field.name}
          {...register(field.name)}
          value={getValues(field.name) ?? ""}
          options={
            field.name === "stateid" || 
            field.name === "birthstate" || 
            field.name === "businessstateid"||
            field.name === "businessstate" ||
            field.name === "receiverstate" ||
            field.name === "receivingstate"
            ? stateOptions[field.name] 
            : field.name === "state"
            ? stateOptions["stateid"]
            : field.name === 'role' 
            ? roles 
            : field.name === 'customertype' 
            ? customerTypes 
            : field.name === 'customersubtype' 
            ? customerSubTypes
            : field.options
          }
          label={field.label}
          name={field.name}
          errorMessage={errors[field.name]?.message}
          disabled={field.disabled || disable}
          required={field.validation?.required}
          onChange={(e) => {
            if (field.name === "areaCode") {
              setValue(field.name, e.target.value);
            } else if (field.name === 'customertype') {
              setSelectedCustomerType(e.target.value);
              setValue(field.name, e.target.value);
            }
            else {
              setValue(field.name, e.target.value);
            }
            trigger(field.name);
          }}
          buttonPressed={buttonPressed}
        />
      );
      case "toggle": // New case for toggle
      return (
        <Box key={field.name} sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography sx={{fontSize: '12px'}}>{field.label}</Typography>
            <Switch
              {...register(field.name)}
              checked={getValues(field.name)} // Ensures boolean value for checked state
              value={getValues(field.name)}
              onChange={(e) => {
                if(field.name === "ismerchant") {
                  handleAddBussinessToggleBit(Boolean(e.target.checked === true))
                }
                setValue(field.name, Boolean(e.target.checked === true)); // Update the value when toggled
                trigger(field.name);
              }}
              disabled={field.disabled || disable}
              inputProps={{ "aria-label": field.label }}
            />
        </Box>
      );
    default:
      return null;
  }
};

export const renderEditField = (
  field, 
  selectOption, 
  register, 
  errors, 
  stateOptions, 
  setValue, 
  trigger, 
  autocompleteRef,
  getValues,
  isLoaded,
  disable,
  roles,
  fieldValue,
  control,
  buttonPressed,
  customerTypes,
  customerSubTypes,
  setSelectedCustomerType,
  configData
) => {
  const onLoad = (autocompleteInstance) => {
    autocompleteRef.current = autocompleteInstance;
  };

  const handlePlaceChanged = () => {
    if (autocompleteRef.current) {
      const place = autocompleteRef.current.getPlace();

      // console.log(field)

      if (place.address_components) {
        let address = "", city = "", state = "", country = "", zip = "";

        place.address_components.forEach((component) => {
          const types = component.types;
          if (types.includes("street_number") || types.includes("route") || types.includes("neighborhood")) {
            address = `${address} ${component.long_name}`.trim();
          }
          if (types.includes("locality")) {
            city = component.long_name;
          }
          if (types.includes("administrative_area_level_1")) {
            state = component.short_name;
          }
          if (types.includes("country")) {
            country = component.short_name;
          }
          if (types.includes("postal_code")) {
            zip = component.long_name;
          }
        });

        // Update your form fields with the extracted data
        if (field.name === "address") {
          setValue("address", address, { shouldValidate: true });
          setValue("city", city, { shouldValidate: true });
          // setValue("stateid", state, { shouldValidate: true });
          // setValue("state", state, { shouldValidate: true });
          // setValue("country", country, { shouldValidate: true });
          setValue("zip", zip, { shouldValidate: true });
        }
        else {
          // console.log(field)
          setValue("businessaddress1", address, { shouldValidate: true });
          setValue("businesscity", city, { shouldValidate: true });
          // setValue("businessstate", state, { shouldValidate: true });
          // setValue("businesscountry", country, { shouldValidate: true });
          setValue("businesszipcode", zip, { shouldValidate: true });
        }
      }
    }
  };

  switch (field.type) {
    case "text":
    case "email":
    case "number":
    case "date":
      if (field.name === "address" || field.name === "businessaddress1") {

        if (!isLoaded) {
          return <p>Loading Google Maps...</p>; // You can customize this loading indicator
        }

        return (
          <Box 
          sx={{
            minWidth: "50%",
          }}
          >
            {configData.showAddress ? 
            <Autocomplete
              onLoad={onLoad}
              onPlaceChanged={() => handlePlaceChanged}
            >
              <EditInput
                {...register(field.name)}
                label={field.label}
                type={field.type}
                placeholder={field.placeholder}
                errorMessage={errors[field.name]?.message}
                disabled={field.disabled || disable}
                required={field.validation?.required}
                onChange={(e) => {
                  // console.log(e)
                  setValue(field.name, e.target.value);
                  trigger(field.name);
                }}    
                buttonPressed={buttonPressed} 
              />
            </Autocomplete>
            :
            <EditInput
                {...register(field.name)}
                label={field.label}
                type={field.type}
                placeholder={field.placeholder}
                errorMessage={errors[field.name]?.message}
                disabled={field.disabled || disable}
                required={field.validation?.required}
                onChange={(e) => {
                  // console.log(e)
                  setValue(field.name, e.target.value);
                  trigger(field.name);
                }}    
                buttonPressed={buttonPressed} 
              />
            }
          </Box>
        );
      } 
      else if (field.name === "phoneno") {
        return (
          <Controller
            name="phoneno"
            control={control}
            defaultValue="" // Ensure a default value is provided
            render={({ field }) => (
              <EditInput
                {...register(field.name)}
                label="Phone No."
                type={field.type}
                placeholder={field.placeholder}
                errorMessage={errors.phoneno?.message}
                disabled={field.disabled || disable}
                required={field.validation?.required}
                onChange={(e) => {
                  setValue(field.name, e.target.value);
                  trigger(field.name);
                }}     
                buttonPressed={buttonPressed}          
              />
            )}
          />
        );
      }
      
      
      else {
        return (
          <EditInput
            {...register(field.name)}
            label={field.label}
            type={field.type}
            placeholder={field.placeholder}
            errorMessage={errors[field.name]?.message}
            disabled={field.disabled || disable}
            required={field.validation?.required}
            onChange={(e) => {
              if (field.type === "date") {
                setValue(field.name, e);
              }
              else {
                setValue(field.name, e.target.value);
                trigger(field.name);
              }
            }}    
            value={decodeHtmlEntities(getValues(field.name)) ?? ""}
            buttonPressed={buttonPressed} 
            />
        );
      }
    case "radio":
      const options = typeof field.options === "string" ? JSON.parse(field.options) : field.options;
      return (
        <div key={field.name}>
          {field.label}:{" "}
          {options.map((option) => (
            <label key={option.value}>
              <input
                type="radio"
                value={option.value}
                {...register(field.name)}
              />
              {option.label}
            </label>
          ))}
          <p>{errors.errorMessage}</p>
        </div>
      );
    // Need to review for better dynamic rendering
    case "select":
      // if ((field.name === "country" || field.name === "state") && Array.isArray(field.options) && field.options.length > 0) {
      //   const currentValue = getValues(field.name);
      //   if (!currentValue) {
      //     setValue(field.name, field.options[0].value);
      //   }
      // }
      
      return (
        <RegistrationSelect
          key={field.name}
          {...register(field.name)}
          value={getValues(field.name)}
          options={
            field.name === "stateid" || 
            field.name === "birthstate" || 
            field.name === "businessstateid" ||
            field.name === "businessstate"
            ? stateOptions[field.name] 
            : field.name === "state"
            ? stateOptions["stateid"]
            : field.name === 'role' 
            ? roles 
            : field.name === 'customertype' 
            ? customerTypes
            : field.name === 'customersubtype' || field.name === 'newusersubtype'
            ? customerSubTypes
            : field.options
          }
          label={field.label}
          name={field.name}
          errorMessage={errors[field.name]?.message}
          disabled={field.disabled || disable}
          required={field.validation?.required}
          onChange={(e) => {
            if (field.name === 'customertype') {
              setSelectedCustomerType(e.target.value);
              setValue(field.name, e.target.value);
            }
            // console.log(field.name, e.target.value);
            setValue(field.name, e.target.value);
            trigger(field.name);
          }}
          isEdit={true}
          buttonPressed={buttonPressed} 
        />
      );
      case "toggle": // New case for toggle
      return (
        <Box key={field.name} sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography sx={{fontSize: '12px'}}>{field.label}</Typography>
          <Switch
            {...register(field.name)}
            checked={getValues(field.name)} // Ensures boolean value for checked state
            value={getValues(field.name)}
            onChange={(e) => {
              // console.log(e.target)
              setValue(field.name, Boolean(e.target.checked)); // Update the value when toggled
              trigger(field.name);
            }}
            disabled={field.disabled || disable}
            inputProps={{ "aria-label": field.label }}
          />
        </Box>
      );
    default:
      return null;
  }
};

//This function is used to render the fields in the form with the base styling
export const renderBaseField = (field, selectOption, register, errors, getValues, setValue) => {
  switch (field.type) {
    case "text":
    case "email":
    case "number":
    case "date":
      return (
        <BaseInput
          {...register(field.name)}
          label={field.label}
          type={field.type}
          placeholder={field.placeholder}
          errorMessage={errors[field.name]?.message}
          disabled={field.disabled}
        />
      );
      case "datetime":
        return (
          <>
          <div className="base-input">
            <InputLabel className="label-header" sx={{
              fontWeight: '800', 
              lineHeight: '33.6px',
              color: '#6b7280',
              fontFamily: 'Nunito',
              fontSize: '14px',
              fontStyle: 'normal',
            }}>
              {field.label}
            </InputLabel>
          </div>
          {/* <LocalizationProvider dateAdapter={AdapterDateFns} key={field.name}>
            <DateTimePicker
              value={getValues(field.name) ? new Date(getValues(field.name)) : null}
              onChange={(newDateTime) => {
                if (newDateTime && !isNaN(newDateTime)) {
                  setValue(field.name, newDateTime);
                }
              }}
              sx={{
                width: '100%',
                '& .MuiInputBase-root': {
                  borderRadius: '4px',
                  padding: '4px 8px',
                  height: '35px',
                },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  error={!!errors[field.name]}
                  helperText={errors[field.name]?.message}
                  disabled={field.disabled}
                  sx={{
                    fontSize: "14px",
                    "& .MuiInputBase-root": {
                      height: "35px",
                      fontSize: "14px",
                    },
                  }}
                />
              )}
              inputFormat="yyyy/MM/dd HH:mm:ss"
            />
          </LocalizationProvider> */}
          <input
            type="datetime-local"
            className="batch-date"
            value={getValues(field.name) || ""}
            onChange={(e) => setValue(field.name, e.target.value)}
            disabled={field.disabled}
            style={{
              width: "100%",
              height: "35px",
              padding: "4px 8px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
          />
        </>
        );
    case "radio":
      return (
        <div key={field.name}>
          {field.label}:{" "}
          {field.options.map((option) => (
            <label key={option.value}>
              <input
                type="radio"
                value={option.value}
                {...register(field.name)}
              />
              {option.label}
            </label>
          ))}
          <p>{errors.errorMessage}</p>
        </div>
      );
    case "select":
      // console.log("Select---------------",field)

      return (
        <BaseSelect
          key={field.name}
          {...register(field.name)}
          value={getValues(field.name)}
          options={field.options}
          label={field.label}
          name={field.name}
          errorMessage={errors}
          disabled={field.disabled}
          onChange={(e) => {
            // console.log(field.name, e.target.value);
            setValue(field.name, e.target.value);
          }}
        />
      );
    default:
      return null;
  }
};

//This is for when a date is entered into react hook forms to convert it to yyyy-mm-dd
export function formatDate(dateString) {
  const isValidFormat = /^\d{4}-\d{2}-\d{2}$/.test(dateString);

  if (isValidFormat) {
    return dateString; // Return as-is if already in correct format
  }

  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
}

//The functions below converts the form format from the backend to a format that can be used in the form component
export function convertFormsToJson(formArray) {
  let sortedArray = sortFormsByTabSort(formArray);

  return sortedArray.map((form) => {
    const {
      type,
      name,
      label,
      validation,
      source,
      core,
      options,
      disabled,
      formgroup,
      tabSort
    } = form;

    let convertedForm = {
      type: type,
      name: name,
      label: label,
      validation: validation,
      placeholder: type === "text" ? `Enter your ${label}` : undefined,
      core: core,
      options: options,
      disabled: disabled,
      formgroup: formgroup,
      tabSort: tabSort
    };

    if (type === "select") {
      convertedForm.options = getOptionsForSelect(name, options);
    }

    // console.log(convertedForm)

    return convertedForm;
  });
}

//This function is used to get the options for the select field in the form
export function getOptionsForSelect(name, options) {
  const constantsState = getConstantsState();
  let formData = constantsState.formSelectData;

  // if (name === "status") {
  //   return [
  //     { value: "0", label: "Pending", key: "pending" },
  //     { value: "1", label: "Active", key: "active" },
  //     { value: "5", label: "Disable", key: "disable" },
  //   ];
  // }

  let optionsSource = formData[name];

  if (optionsSource) {
    return optionsSource;
  }

  if (options) {
    let parsedOptions = JSON.parse(options);
    return parsedOptions;
  }

  return [{ value: "na", label: "Not Available", key: "option1" }];
}

//Get Redux function state for constants
function getConstantsState() {
  const state = store.getState();
  const constants = state.constants;
  return constants;
}

//Sort the forms by the tab sort
export function sortFormsByTabSort(forms) {
  return forms.sort((a, b) => {
    if (a.tabSort === null && b.tabSort === null) {
      return 0;
    }
    if (a.tabSort === null) {
      return 1;
    }
    if (b.tabSort === null) {
      return -1;
    }
    return a.tabSort - b.tabSort;
  });
}

// Search to get the security roles
export function searchAppsByLabel(searchTerm, state) {
  const lowercasedSearchTerm = searchTerm.toLowerCase();
  return Array.isArray(state) 
  ? 
  state.filter((app) => app.label.toLowerCase().includes(lowercasedSearchTerm))
  :
  state;
}

// Utility function to normalize field types
export const normalizeFieldType = (type) => {
  if (["text", "email", "number", "date"].includes(type)) {
    return "input"; 
  }
  return type; 
};

  /**
 * Recursively normalizes boolean-like values in an object.
 * Converts 'true', 'false', true, false strings and booleans into actual boolean values.
 * @param {Object} data - The object containing data to normalize.
 * @returns {Object} - A new object with normalized boolean fields.
 */
  export const normalizeBooleans = (data) => {
    if (typeof data !== 'object' || data === null) return data;
  
    return Object.entries(data).reduce((acc, [key, value]) => {
      // Check if the value is a boolean-like string or boolean and convert
      if (typeof value === 'string' && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
        acc[key] = value.toLowerCase() === 'true';
      } else if (typeof value === 'boolean') {
        acc[key] = value; // Preserve existing booleans
      } else if (typeof value === 'object') {
        // Recursively normalize nested objects
        acc[key] = normalizeBooleans(value);
      } else {
        acc[key] = value; // Keep other types intact
      }
      return acc;
    }, {});
  };

  export const camelCaseToWords = (string) => {
    let result = string.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
  }

export const getErrorMessage = (response) => {
  let externalErrors = response.payload?.externalAPIResponse?.errors
  let errorMsg = '';
  if (externalErrors) {
    const externalErrorList = Array.isArray(externalErrors.error) ? externalErrors.error : [externalErrors.error];
    for (let error of externalErrorList) {
      errorMsg += `${error?.offendingField ? error.offendingField + ':' : ''} ${error.errorString}`.trim();
    }
    errorMsg = errorMsg.replaceAll(/&amp;#039;/g, "'");
    errorMsg = errorMsg.replaceAll(/4pay/gi, "NCS");
  } else if (response.Status === '2' && response?.payload?.header?.callStatus === '1') {
    errorMsg = "This transaction is under review. Please contact NCS for further assistance @1-649-946-4227 or support@onrevegrand.com";
  } else if (response.Status === '3' && response?.payload?.header?.callStatus === '1') {
    errorMsg = "This transaction can not be completed at this time. Please contact NCS for further assistance @1-649-946-4227 or support@onrevegrand.com ";
  } else if (response.data?.payload?.msg) {

  } else if (response?.payload?.msg) {
    let msg = response.payload.msg;
    msg = msg.split('||');
    for (let msgString of msg) {
      if (msgString === 'something went wrong') continue;
      errorMsg += `${msgString} `;
    }
  } else if (response?.payload?.ResponseText) {
    errorMsg = response.payload.ResponseText;
  } else if (response?.payload?.Errors) {
    let errors = response?.payload?.Errors;
    if (!Array.isArray(errors)) {
      errors = [errors];
    }
    for (let error of errors) {
      errorMsg += error.Error.ErrorMsg;
    }
  }
  return errorMsg;
}

export const getErrorMessage2 = (response, isAutoRetry) => {
  console.log("getErrorMessage_isAutoRetry===========",isAutoRetry);
  let externalErrors = response.payload?.externalAPIResponse?.errors
  let errorMsg = '';
  if (externalErrors) {
    const externalErrorList = Array.isArray(externalErrors.error) ? externalErrors.error : [externalErrors.error];
    for (let error of externalErrorList) {
      errorMsg += `${error?.offendingField ? error.offendingField + ':' : ''} ${error.errorString}`.trim();
    }
    errorMsg = errorMsg.replaceAll(/&amp;#039;/g, "'");
    errorMsg = errorMsg.replaceAll(/4pay/gi, "NCS");
  } 
  else if (isAutoRetry == true && response?.payload?.header?.callStatus === '1') {
    errorMsg = "This transactions is under review. Please contact NCS for further assistance @1-649-946-4227 or support@onrevegrand.com";
  } else if (isAutoRetry == false && response?.payload?.header?.callStatus === '1') {
    errorMsg = "This transactions can not be completed at this time. Please contact NCS for further assistance @1-649-946-4227 or support@onrevegrand.com";
  } 
  else if (response.data?.payload?.msg) {

  } else if (response?.payload?.msg) {
    let msg = response.payload.msg;
    msg = msg.split('||');
    for (let msgString of msg) {
      if (msgString === 'something went wrong') continue;
      errorMsg += `${msgString} `;
    }
  } else if (response?.payload?.ResponseText) {
    errorMsg = response.payload.ResponseText;
  } else if (response?.payload?.Errors) {
    let errors = response?.payload?.Errors;
    if (!Array.isArray(errors)) {
      errors = [errors];
    }
    for (let error of errors) {
      errorMsg += error.Error.ErrorMsg;
    }
  }
  return errorMsg;
}

export const useGoogleMapsLoader = () => {
  const libraries = ["places", "maps"];
  let configVariables = useSelector((state) => state.config.baseConfig);

  return useJsApiLoader({
    googleMapsApiKey: configVariables.googleAPIKey,
    libraries,
    id: "google-map-script",
  });
};

export const getDeviceId = async () => {
  const fp = await FingerprintJS.load();
  const result = await fp.get();
  return result.visitorId;
};

export const getSessionData = () => {
  // const state = store.getState();
  const deviceToken = localStorage.getItem("deviceID");
  const sessionID = localStorage.getItem("sessionID");
  const authUser = localStorage.getItem("authUser");
  // const deviceToken = state.login.deviceToken;
  // const authUser = state.login.user.id;
  // const sessionID = state.login.sessionID;
  return {
    _viewid: sessionStorage.getItem('viewID'),
    _devicetoken: deviceToken,
    enforceSession: true,
    authUser: authUser,
    sessionID: sessionID
  }
}

export const checkSessionIsActive = (response) => {
  try {
    if(response.result.includes("resetSession")) {
      return false;
    }
    return true;
  } catch (error) {
    return true;
  }
}
export const getCountryFlagUrl = (alpha3Code) => {
  const alpha2Code = countries.alpha3ToAlpha2(alpha3Code);
  return alpha2Code
      ? `https://flagcdn.com/w40/${alpha2Code.toLowerCase()}.png`
      : "path-to-default-flag.png"; // Fallback if conversion fails
};

export function decodeHtmlEntities(str) {
  if (typeof str !== "string") return str;

  const txt = document.createElement("textarea");
  let prev = str;
  let decoded = str;

  do {
    prev = decoded;
    txt.innerHTML = prev;
    decoded = txt.value;
  } while (decoded !== prev);

  return decoded;
}    

export const setAsArray = (item) => {
  return Array.isArray(item) ? item : [item];
}

export const findScrollableParent = (el) => {
  while (el.parentElement) {
    el = el.parentElement;
    const style = getComputedStyle(el);
    if (style.overflowY === 'auto' || style.overflowY === 'scroll') {
      return el;
    }
  }
  return null;
}